module.exports = __webpack_public_path__ + "static/media/pre-order-banner.304ccd91.png";